import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(root)/ratgeber/error.tsx");
